import { TemplateGridItem } from "./templateGridItem";
export default TemplateGridItem;
